<template>
  <div
    class="overlay"
    tabindex="0"
    v-if="gallery && gallery.length && lightBoxIsVisible"
    v-on:click="closeLightBox"
  >
    <div class="display-wrap">
      <div class="image-or-video-container">
        <v-img
          v-on:click.stop
          v-if="gallery[currentIndexShown].content_type === 'image'"
          v-bind:src="gallery[currentIndexShown].image.url"
          v-bind:alt="gallery[currentIndexShown].image.alt"
          v-bind:contain="true"
          max-height="100%"
          max-width="100%"
        ></v-img>
        <div class="embed-wrap">
          <div
            class="ligthbox-embed-container"
            v-if="gallery[currentIndexShown].content_type === 'video'"
            v-html="gallery[currentIndexShown].video"
          ></div>
        </div>
        <div class="lightbox-button prev">
          <v-btn :ripple="false" v-on:click.stop="goToPrevious" role="button">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </div>
        <div class="lightbox-button next">
          <v-btn :ripple="false" v-on:click.stop="goToNext" role="button">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="close-button">
      <v-btn :ripple="false" v-on:click="closeLightBox" role="button">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "LightBoxGallery",
  props: {
    gallery: Array,
    contrastMode: Boolean
  },
  data: () => {
    return {
      lightBoxIsVisible: false,
      currentIndexShown: null
    };
  },
  mounted() {
    document.addEventListener("keyup", this.handleKeyPress.bind(this));
  },
  methods: {
    showElement(elementIndex) {
      this.lightBoxIsVisible = true;
      this.currentIndexShown = elementIndex;
    },
    handleKeyPress(keyEvent) {
      if (
        keyEvent.key === "Escape" ||
        (keyEvent.keyCode === 27 && this.lightBoxIsVisible)
      ) {
        this.closeLightBox();
      }

      if (
        keyEvent.key === "ArrowLeft" ||
        (keyEvent.keyCode == 37 && this.lightBoxIsVisible)
      ) {
        this.goToPrevious();
      }

      if (
        keyEvent.key === "ArrowRight" ||
        (keyEvent.keyCode == 39 && this.lightBoxIsVisible)
      ) {
        this.goToNext();
      }
    },
    closeLightBox() {
      if (this.lightBoxIsVisible) {
        this.lightBoxIsVisible = false;
        this.currentIndexShown = null;
      }
    },
    goToNext() {
      this.currentIndexShown =
        this.currentIndexShown + 1 === this.gallery.length
          ? 0
          : this.currentIndexShown + 1;
    },
    goToPrevious() {
      this.currentIndexShown =
        this.currentIndexShown - 1 < 0
          ? this.gallery.length - 1
          : this.currentIndexShown - 1;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../styles/_overrides.scss";

.overlay {
  background-color: rgba(0, 0, 0, 0.85);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.lightbox-button {
  position: absolute;
  height: 100%;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: red;
  z-index: 200;
  &.prev {
    left: 0;
  }
  &.next {
    right: 0;
  }

  @media (max-width: nth(nth($breakpoints, 2), 2)) {
    align-items: flex-end;
  }
}

.close-button {
  position: fixed;
  top: 0;
  right: 0;
}

.display-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.image-or-video-container {
  width: 90%;
  max-height: 90%;
  height: 90%;
  max-height: 90%;
  position: relative;
}

::v-deep {
  .v-btn {
    min-width: 40px;
    padding: 0;
  }

  .ligthbox-embed-container {
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    margin-top: -25%;
    padding-bottom: 50%;
    height: 0;
    max-height: 100%;
    overflow: hidden;
    @media (max-width: nth(nth($breakpoints, 2), 2)) {
      top: 0;
      margin-top: 0;
    }
  }

  .ligthbox-embed-container iframe,
  .ligthbox-embed-container object,
  .ligthbox-embed-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>